<template></template>
<script>
// 单独引用axios
import axios from "axios";
// 引入API
import { getAuthCode, getSessionId } from "../../api/HttpService";
export default {
  data: function () {
    return {
      routeName: null,
      channelCode: null,
      apiPath: null,
      ai_app_code: null,
      // 跳转延迟时间  纠错用  正常设置为0即可
      timeout: 1000,
      clientTypeFromBiz: null,
      channelCodeFromBiz: null,
      userInputs: null,
    };
  },
  mounted: async function () {
    console.log("oauthPage加载了", this.$route.query);
    this.channelCode = this.$route.query.channelCode;
    this.ai_app_code = this.$route.query.ai_app_code;
    this.clientTypeFromBiz = this.$route.query.clientTypeFromBiz;
    this.channelCodeFromBiz = this.$route.query.channelCode;
    if (this.$route.query.userInputs) {
      this.userInputs = decodeURIComponent(this.$route.query.userInputs);
    }
    // 从容器获取宿主应用信息
    let result = await this.getSystemInfo();
    console.log("容器返回");
    console.log(result);
    // 如果没拿到返回值 直接跳到错误页
    if (!result) {
      // this.$router.replace({
      //   name: "ChannelErrorPage",
      //   query: {
      //     client: this.clientTypeFromBiz,
      //     channel: this.channelCodeFromBiz,
      //   },
      // });
      // return;
    }
    let channelCodeFromContainer = result.responseData.appName;
    // 容器渠道和业务要求的渠道不一致(dxlc  cxnt)
    if (channelCodeFromContainer != this.channelCodeFromBiz) {
      // this.$router.replace({
      //   name: "ChannelErrorPage",
      //   query: {
      //     client: this.clientTypeFromBiz,
      //     channel: this.channelCodeFromBiz,
      //   },
      // });
      // return;
    }
    window.localStorage.setItem("channelCode_AI", this.channelCode);
    window.localStorage.setItem("clientType_AI", "app");
    //记录渠道为亮啦app
    window.localStorage.setItem("channel_App", "app");
    // 计算apiPath
    switch (this.channelCode) {
      case "dxlc":
        this.apiPath = "./liuzhouGateway";
        break;
      case "cxnt":
        this.apiPath = "./nantongGateway";
        break;
    }
    console.log("oauthPage加载了");
    console.log(window.location.href);
    console.log(this.$route.query);
    // 先判断有没有上次残留的sessionId
    if (window.localStorage.getItem("sessionId") != null) {
      console.log("存在sessionId");
      // 如果存在sessionId   直接拿着sessionId 换authCode
      // 拿着这个sessionId去换authCode
      getAuthCode(
        {
          newFlag: true,
        },
        this.apiPath
      )
        .then(({ res }) => {
          console.log(res);
          // 成功  代表着当前缓存里这个sessionId是生效的
          if (res.code == "SUCCESS" && res.originalData.code == "SUCCESS") {
            // 拿到authCode
            // 再去换sessionId
            getSessionId({
              authCode: res.data,
              system: this.channelCode,
            })
              .then(({ res }) => {
                console.log(res);
                if (res.code == "SUCCESS") {
                  // 拿到了最终的sessionId
                  window.localStorage.setItem(
                    "sessionId_AI",
                    res.originalData.data.sessionId
                  );
                  window.localStorage.setItem(
                    "appId_AI",
                    res.originalData.data.appId
                  );
                  window.localStorage.setItem(
                    "userId_AI",
                    res.originalData.data.userId
                  );
                  const thisUserId = res.originalData.data.userId;
                  window._czc && window._czc.push(["_setUUid", thisUserId]);
                  // 如果此时地址栏中存在ai_app_code
                  // 那么跳到列表后，要直接加载该智能体
                  if (this.ai_app_code) {
                    console.log("地址栏中存在ai_app_code", this.ai_app_code);
                    this.$router.replace({
                      name: "ChatListPage",
                      params: {
                        autoJumpToAgent: this.ai_app_code,
                        userInputs: this.userInputs || null,
                      },
                    });
                  }
                  // 跳到发现页
                  else if (this.$route.query.jumpFind) {
                    this.$router.replace({
                      name: "ChatListPage",
                      params: {
                        jumpFind: true,
                      },
                    });
                  } else {
                    this.$router.replace({
                      name: "ChatListPage",
                    });
                  }
                }
              })
              .catch((err) => {});
          }
          // 失败  有可能是sessionId失效了
          else {
            window.localStorage.removeItem("sessionId");
            setTimeout(() => {
              this.Oauth();
            }, this.timeout);
          }
        })
        .catch((err) => {});
    } else {
      // 查看是否有authCode和clientId
      let authCode = this.GetQueryString("authCode");
      let clientId = this.GetQueryString("clientId");
      if (authCode && clientId) {
        // 已授权
        var url = "";
        if (this.channelCode == "dxlc") {
          url = process.env.VUE_APP_OAUTH_QUERY_URL_DXLC;
        } else if (this.channelCode == "cxnt") {
          url = process.env.VUE_APP_OAUTH_QUERY_URL_CXNT;
        }
        // 获取sessionId
        let params = {
          authCode: authCode,
          clientId: clientId,
          grantType: "authorization_code",
        };
        var queryString = [];
        for (var key in params) {
          queryString.push("".concat(key, "=").concat(params[key]));
        }

        if (queryString.length > 0) {
          queryString = queryString.join("&");
          url += "?".concat(queryString);
        }
        console.log(url);
        await axios.get(url).then((res) => {
          console.log(res);
          if (res.data.bizCode == "SUCCESS" && res.data.code == "SUCCESS") {
            // 拿到了sessionId
            var result = JSON.parse(res.data.bizResp);
            window.localStorage.setItem("sessionId", result.sessionId);
            // 拿到了第一个sessionId
            // 拿着这个sessionId去换authCode
            getAuthCode(
              {
                newFlag: true,
              },
              this.apiPath
            )
              .then(({ res }) => {
                console.log(res);
                if (res.code == "SUCCESS") {
                  // 拿到authCode
                  // 再去换sessionId
                  getSessionId({
                    authCode: res.data,
                    system: this.channelCode,
                  })
                    .then(({ res }) => {
                      console.log(res);
                      if (res.code == "SUCCESS") {
                        // 拿到了最终的sessionId
                        window.localStorage.setItem(
                          "sessionId_AI",
                          res.originalData.data.sessionId
                        );
                        window.localStorage.setItem(
                          "appId_AI",
                          res.originalData.data.appId
                        );
                        window.localStorage.setItem(
                          "userId_AI",
                          res.originalData.data.userId
                        );
                        const thisUserId = res.originalData.data.userId;
                        window._czc &&
                          window._czc.push(["_setUUid", thisUserId]);

                        let url =
                          process.env.VUE_APP_URL +
                          `#/OauthPage?channelCode=${this.$route.query.channelCode}&clientTypeFromBiz=${this.$route.query.clientTypeFromBiz}`;

                        if (this.ai_app_code) {
                          console.log(
                            "地址栏中存在ai_app_code",
                            this.ai_app_code
                          );
                          url =
                            url +
                            `&ai_app_code=${this.ai_app_code}&userInputs=${this.userInputs}`;
                          window.history.replaceState(
                            null,
                            document.title,
                            url
                          );
                          console.log("replaceState", window.location.href);
                          this.$router.replace({
                            name: "ChatListPage",
                            params: {
                              autoJumpToAgent: this.ai_app_code,
                              userInputs: this.userInputs || null,
                            },
                          });
                        }
                        // 跳到发现页
                        else if (this.$route.query.jumpFind) {
                          window.history.replaceState(
                            null,
                            document.title,
                            url
                          );
                          this.$router.replace({
                            name: "ChatListPage",
                            params: {
                              jumpFind: true,
                            },
                          });
                        } else {
                          window.history.replaceState(
                            null,
                            document.title,
                            url
                          );
                          console.log("replaceState", window.location.href);
                          this.$router.replace({
                            name: "ChatListPage",
                          });
                        }
                      }
                    })
                    .catch((err) => {});
                }
              })
              .catch((err) => {});
          } else {
            // 换取sessionId失败 重新授权
            console.log("sessionId换取失败");
            setTimeout(() => {
              this.Oauth();
            }, this.timeout);
          }
        });
      } else {
        // 未授权
        console.log("未授权");
        setTimeout(() => {
          this.Oauth();
        }, this.timeout);
      }
    }
  },
  methods: {
    getSystemInfo: async function () {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(false);
        }, 3000);
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
        var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isAndroid) {
          DXLC_JSSDK("getSystemInfo", {}, (result) => {
            let res = JSON.parse(result);
            resolve(res);
          });
        } else if (isIos) {
          DXLC_JSSDK(
            "getSystemInfo",
            {},
            (success) => {
              resolve(success);
            },
            (err) => {
              resolve(false);
            }
          );
        }
      });
    },
    GetQueryString: function (name) {
      const urlParams = new URLSearchParams(window.location.search);
      const value = urlParams.get(name);
      return value ? decodeURIComponent(value) : null;
    },
    // 执行oauth授权
    Oauth: function () {
      let VUE_APP_OAUTH_URL;
      if (this.channelCode == "dxlc") {
        VUE_APP_OAUTH_URL = process.env.VUE_APP_OAUTH_URL_DXLC;
      } else if (this.channelCode == "cxnt") {
        VUE_APP_OAUTH_URL = process.env.VUE_APP_OAUTH_URL_CXNT;
      }
      // 如果地址栏中包含ai_app_code
      if (this.ai_app_code) {
        let _url;
        _url =
          VUE_APP_OAUTH_URL +
          encodeURIComponent(
            process.env.VUE_APP_URL +
              `#/OauthPage?channelCode=${this.channelCode}&ai_app_code=${this.ai_app_code}&clientTypeFromBiz=${this.clientTypeFromBiz}&userInputs=${this.userInputs}`
          ) +
          "&state=123";
        console.log(_url);
        setTimeout(() => {
          window.location.href = _url;
        }, this.timeout);
      }
      // 如果地址栏中包含jumpFind
      else if (this.$route.query.jumpFind) {
        let _url;
        _url =
          VUE_APP_OAUTH_URL +
          encodeURIComponent(
            process.env.VUE_APP_URL +
              `#/OauthPage?channelCode=${this.channelCode}&jumpFind=true&clientTypeFromBiz=${this.clientTypeFromBiz}`
          ) +
          "&state=123";
        console.log(_url);
        setTimeout(() => {
          window.location.href = _url;
        }, this.timeout);
      } else {
        let _url;
        _url =
          VUE_APP_OAUTH_URL +
          encodeURIComponent(
            process.env.VUE_APP_URL +
              `#/OauthPage?channelCode=${this.channelCode}&clientTypeFromBiz=${this.clientTypeFromBiz}`
          ) +
          "&state=123";
        console.log(_url);
        setTimeout(() => {
          window.location.href = _url;
        }, this.timeout);
      }
    },
  },
};
</script>

<style></style>
